import React from 'react';
import { Box, Typography } from '@mui/material';
import { rowReveal } from './motion';

/** Avatar (initials) + title + sub line + a right-hand value or element. */
const PersonRow = ({ initials, color = '#64748b', title, sub, right, onClick, first, index = 0 }) => (
  <Box onClick={onClick}
    sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.1, borderTop: first ? 0 : '1px solid', borderColor: 'divider', cursor: onClick ? 'pointer' : 'default', '&:first-of-type': { borderTop: 0 }, ...rowReveal(index) }}>
    <Box sx={{ width: 32, height: 32, borderRadius: '50%', bgcolor: color, color: '#fff', fontSize: '0.75rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      {initials}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600 }} noWrap title={typeof title === 'string' ? title : undefined}>{title}</Typography>
      {sub && <Typography component="div" sx={{ fontSize: '0.75rem', color: 'text.secondary' }} noWrap>{sub}</Typography>}
    </Box>
    {typeof right === 'string' || typeof right === 'number'
      ? <Typography sx={{ fontSize: '0.8125rem', fontWeight: 700, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{right}</Typography>
      : right}
  </Box>
);

export const initialsOf = (name = '') => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?';

const COLORS = ['#0ea5e9', '#8b5cf6', '#f97316', '#14b8a6', '#ef4444', '#f59e0b', '#10b981', '#6366f1'];
export const colorOf = (key = '') => COLORS[Array.from(String(key)).reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7) % COLORS.length];

export default PersonRow;
